import React, { useState } from "react";
import * as Yup from "yup";
import { TEXT, DATE_TIME, CURRENCY, INTEGER, COMPONENT, FILE_UPLOAD_DROPZONE, TEXT_DISABLED, CHECKBOX } from "../../../components/form/VinSystemsFormBuilderFieldTypes";
import { useSelector } from "react-redux";
import GenericAppFormBuilder from "../GenericApp/GenericAppFormBuilder";
import PropTypes from "prop-types";
import GenderAutocomplete from "../../../components/form-component/autocomplete/GenderAutocomplete";
import BrandAutocomplete from "../../../components/form-component/autocomplete/BrandAutocomplete";
import ProductCategoryAutocomplete from "../../../components/form-component/autocomplete/ProductCategoryAutocomplete";
import StyleAutocomplete from "../../../components/form-component/autocomplete/StyleAutocomplete";
import ProductTypeAutocomplete from "../../../components/form-component/autocomplete/ProductTypeAutocomplete";

const FormValidation = Yup.object().shape({
  name: Yup.string().required("Required"),
});

const formObj = {
  name:'product-app-form',
  validation: FormValidation,
  groups: [
    {
      title: 'Main',
      subTitle: '',
      fields: [
        { name: 'name', label: 'Name', type: TEXT, fieldProps: {} },
        { name: 'description', label: 'Description', type: TEXT, fieldProps: {} },
        { name: 'price', label: 'Price', type: CURRENCY, fieldProps: {} },
        { name: 'priceOld', label: 'Price Old', type: CURRENCY, fieldProps: {} },
        { name: 'active', label: 'Active', type: CHECKBOX, fieldProps: {} },
        { name: 'code', label: 'Code', type: TEXT, fieldProps: {} },
        { name: 'size', label: 'Size', type: TEXT, fieldProps: {} },
        { name: 'colorPrimary', label: 'Color Primary', type: TEXT, fieldProps: {} },
        { name: 'colorSecondary', label: 'Color Secondary', type: TEXT, fieldProps: {} },
        { name: 'type', label: 'Type', type: COMPONENT, fieldProps: { component: ProductTypeAutocomplete } },
        { name: 'category', label: 'Category', type: COMPONENT, fieldProps: { component: ProductCategoryAutocomplete } },
        { name: 'brand', label: 'Brand', type: COMPONENT, fieldProps: { component: BrandAutocomplete } },
        { name: 'style', label: 'Style', type: COMPONENT, fieldProps: { component: StyleAutocomplete } },
        ]
    },
    {
      title: 'Image',
      subTitle: '',
      fields: [
        { name: 'imageUrlLarge', label: 'Large', type: FILE_UPLOAD_DROPZONE, fieldProps: {} },
        { name: 'imageUrlMedium', label: 'Medium', type: FILE_UPLOAD_DROPZONE, fieldProps: {} },
        { name: 'imageUrlSmall', label: 'Small', type: FILE_UPLOAD_DROPZONE, fieldProps: {} },
      ]
    },
    {
      title: "Info",
      fields: [
        { name: "createdDate", label: "Created", type: TEXT_DISABLED, fieldProps: {} },
        { name: "modifiedDate", label: "Modified", type: TEXT_DISABLED, fieldProps: {} },
        { name: "deletedDate", label: "Deleted", type: TEXT_DISABLED, fieldProps: {} }
      ]
    }
  ],
  record: null
}

const ProductAppForm = (props) => {
  const { currentRecord } = useSelector(({ genericAppReducer }) => genericAppReducer);
  const [obj, setObj] = useState( currentRecord);

  // const handleExtraFields = (formik) => {
  //   return(
  //     <FormikFileUploadField formik={formik} fieldName={'slug'} isPreviewOnly={true} isPublic={false} label={'Slug'}/>
  //   )
  // }

  return (
    <GenericAppFormBuilder  currentRecord={obj} formObj={formObj} onSubmit={props.onSubmit} />
  )
}

ProductAppForm.propTypes = {
  onSubmit: PropTypes.func
}

export default ProductAppForm;
